import { Button } from '@ria-client/tw-shadcn/components/button';
import { BrandIcon, type BrandIconName } from '@ria-client/tw-shared-ui';
import type { NodeProps } from '../types';
import { ContentLink } from './lib/content-link';

export type IconCardListProps = NodeProps<{
  title: string;
  subtitle?: string;
  hasBorder?: boolean;
  items: {
    icon: BrandIconName;
    headline?: string;
    subtext?: string;
  }[];
  cta?: {
    href: string;
    text: string;
  };
}>;

export function IconCardList({ props }: IconCardListProps) {
  const { title, subtitle, hasBorder, items, cta } = props;

  return (
    <div
      className={`flex flex-col items-center justify-center gap-6 p-6 text-center${hasBorder ? ' border border-border' : ''}`}
    >
      <div className="flex flex-col items-center justify-center gap-2">
        {/* 32px: Theme/index.ts:842; no matching Tailwind size. */}
        <h1 className="font-display text-[32px] font-normal md:text-4xl">{title}</h1>
        {subtitle ? <p className="typography-body">{subtitle}</p> : null}
      </div>
      <div className="flex w-4/5 flex-col justify-center gap-x-4 gap-y-6 md:w-auto md:flex-row">
        {items.slice(0, 4).map((item, index) => (
          <div className="flex flex-1 flex-col items-center gap-2" key={index}>
            <BrandIcon name={item.icon} size={56} />
            {item.headline ? <p className="typography-text-bold">{item.headline}</p> : null}
            {item.subtext ? <p className="typography-body">{item.subtext}</p> : null}
          </div>
        ))}
      </div>
      {cta ? (
        <Button asChild>
          <ContentLink href={cta.href}>{cta.text}</ContentLink>
        </Button>
      ) : null}
    </div>
  );
}
